"use client";
import * as React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import {
  AppBar,
  Drawer,
  Box,
  CssBaseline,
  IconButton,
  List,
  Toolbar,
  Typography,
  Avatar,
  Grid,
  Tooltip,
  Button,
  MenuItem,
  Menu,
  Fade,
  useMediaQuery,
  useTheme,
  ListItemIcon,
  Divider,
} from "@mui/material";

import {
  TreeOne,
  Myworkspace,
  Recurring,
  Teamticket,
  Master,
  DashBoardIcon,
  CustomerIcon,
  DashBoardActive,
  CustomerActiveIcon,
  MyWorkspaceActive,
  TeamTicketActive,
  RecurringActiveIcon,
  MasterActive,
  CreatedActive,
  Created,
  ReportMain,
  NotesI,
  NoteActive,
  ApprovalActive,
  ApprovalInactive,
  RedTree,
} from "../Assets/Icon";

import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";
import Content from "./Content";
import { useDispatch } from "react-redux";
import { useState } from "react";
import LogoutConfirmPop from "../LogoutConfirmPop";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import GlobalSearch from "../Components/GlobalSearch";
import NotificationBell from "../Components/NotificationBell";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Settings from "@mui/icons-material/Settings";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import Logout from "@mui/icons-material/Logout";
import TvIcon from "@mui/icons-material/Tv";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import axios from "axios";
import { FamilyProducts } from "@tabtree/react-family-products";
import AppsIcon from "@mui/icons-material/Apps";
import { RssFeed } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import AccountBoxIcon from "@mui/icons-material/AccountBox";
import QrCodes from "./QrCodes";

const drawerWidthExpanded = 205;
const drawerWidthCollapsed = 60;

const XIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

function MainLayout(props) {
  const { window } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [sidebarExpanded, setSidebarExpanded] = React.useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSearch, setIsSearch] = useState(false);
  const [subsContent, setSubsContent] = useState("");

  const [mobileDrawer, setMobileDrawer] = useState(false);

  const config = global.$userData.logindata.crm_app_license_master;
  const isProduct = config.Ticket_productconfig == "Yes";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const DH = new Date().getHours();
  const TT =
    DH >= 0 && DH < 12
      ? "Good Morning"
      : DH >= 12 && DH <= 15
        ? "Good Afternoon"
        : "Good Evening";

  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    setSidebarExpanded(true);
  };

  const handleOpenUserMenu = () => {
    if (isMobile) {
      setMobileDrawer(true);
    } else {
      setOpenDrawer(true);
    }
  };

  const handleCloseUserMenu = () => {
    if (isMobile) {
      setMobileDrawer(false);
    } else {
      setOpenDrawer(false);
    }
  };

  const [activeLink, setActiveLink] = React.useState("Dashboard");
  const logout = async () => {
    try {
      const token = localStorage.getItem("refreshToken");

      if (token) {
        await axios.post(`${global.logout}signout`, { token });
      }

      localStorage.clear();
      dispatch({ type: "SET_USER_OUT", payload: false });
      Navigate("/auth");
    } catch (error) {
      console.error("Logout failed", error);
      localStorage.clear();
      dispatch({ type: "SET_USER_OUT", payload: false });
      Navigate("/auth");
    }
  };

  React.useEffect(() => {
    const STab = localStorage.getItem("SideTab");
    setActiveLink(STab ?? "Dashboard");
  }, []);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [toggleDashboard, setToggleDashboard] = useState(false);
  const [toggleReports, setToggleReports] = useState(false);

  // Knowledge base: approvers see how many articles are waiting for them.
  const [kbPending, setKbPending] = useState(0);
  // KB-RESTRICTIONS-OFF: everyone sees the pending count. To restore, use:
  // const isKbApprover =
  //   global?.$userData?.logindata?.AccessAdminTicket === "Yes" ||
  //   global?.$userData?.logindata?.TicketingDepartmentAdmin === "Yes";
  const isKbApprover = true;
  React.useEffect(() => {
    if (!isKbApprover) return undefined;
    let alive = true;
    global.$axios
      .get("kb/admin/articles", { params: { status: "pending", limit: 1 } })
      .then((res) => {
        if (alive && res?.data?.Status === 200) setKbPending(res.data.Counts?.pending || 0);
      });
    return () => {
      alive = false;
    };
  }, [isKbApprover, activeLink]);

  const [dashboardMenuAnchor, setDashboardMenuAnchor] = useState(null);

  const handleDashboardMenuOpen = (event) => {
    if (!sidebarExpanded) {
      setDashboardMenuAnchor(event.currentTarget);
    }
  };

  const handleDashboardMenuClose = () => {
    setDashboardMenuAnchor(null);
  };

  const NavItem = ({ icon, label, isActive, onClick, endIcon }) => (
    <Tooltip title={!sidebarExpanded ? label : ""} placement="right">
      <div
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: sidebarExpanded ? "space-between" : "center",
          padding: sidebarExpanded ? "10px 10px" : "10px 5px",
          cursor: "pointer",
          backgroundColor: isActive ? "#fff" : "#0071BC",
          color: isActive ? "#232323" : "#fff",
          transition: "all 0.3s ease",
        }}
      >
        {sidebarExpanded ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              {icon}
              <span style={{ fontWeight: 500 }}>{label}</span>
            </div>
            {endIcon && <div>{endIcon}</div>}
          </>
        ) : (
          <div>{icon}</div>
        )}
      </div>
    </Tooltip>
  );

  const drawerWidth = sidebarExpanded
    ? drawerWidthExpanded
    : drawerWidthCollapsed;

  const drawer = (
    <div
      style={{
        width: drawerWidth,
        background: "#fff",
        height: "100vh",
        transition: "width 0.3s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
          width: `${drawerWidth}px`,
          height: "64px",
          position: "relative",
        }}
      >
        {sidebarExpanded ? (
          <TreeOne style={{ width: "60%" }} />
        ) : (
          <RedTree style={{ width: 40, height: 40 }} />
        )}
      </div>
      <Box
        style={{
          overflowY: "auto",
          height: "calc(100vh - 64px)",
          background: "#0071BC",
        }}
      >
        <List>
          {global?.$userData?.logindata?.AccessAdminTicket === "Yes" ? (
            <>
              <div
                onMouseEnter={handleDashboardMenuOpen}
                onMouseLeave={handleDashboardMenuClose}
              >
                <NavItem
                  icon={
                    activeLink.includes("Dashboard") ? (
                      <DashBoardActive width="30" height="25" />
                    ) : (
                      <DashBoardIcon width="30" height="25" />
                    )
                  }
                  label="Dashboard"
                  isActive={activeLink.includes("Dashboard")}
                  onClick={() => {
                    if (sidebarExpanded) {
                      setToggleReports(false);
                      setToggleDashboard(!toggleDashboard);
                    } else {
                      localStorage.setItem("SideTab", "Dashboard");
                      setActiveLink("Dashboard");
                      navigate("Dashboard");
                    }
                  }}
                  endIcon={
                    sidebarExpanded &&
                    (toggleDashboard ? (
                      <ExpandMoreIcon />
                    ) : (
                      <ChevronRightIcon />
                    ))
                  }
                />

                {/* Hover Menu for Collapsed Sidebar */}
                <Menu
                  anchorEl={dashboardMenuAnchor}
                  open={Boolean(dashboardMenuAnchor)}
                  onClose={handleDashboardMenuClose}
                  TransitionComponent={Fade}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      marginLeft: "8px",
                      minWidth: "180px",
                      backgroundColor: "#fff",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      borderRadius: "8px",
                    },
                  }}
                  MenuListProps={{
                    onMouseLeave: handleDashboardMenuClose,
                  }}
                >
                  <MenuItem
                    selected={activeLink === "Dashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "Dashboard");
                      setActiveLink("Dashboard");
                      navigate("Dashboard");
                      handleDashboardMenuClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "10px 16px",
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        color: "#0071BC",
                        fontWeight: 600,
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Dashboard
                  </MenuItem>
                  <MenuItem
                    selected={activeLink === "AgentDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "AgentDashboard");
                      setActiveLink("AgentDashboard");
                      navigate("AgentDashboard");
                      handleDashboardMenuClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "10px 16px",
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        color: "#0071BC",
                        fontWeight: 600,
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Agent
                  </MenuItem>
                  <MenuItem
                    selected={activeLink === "CustomerDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "CustomerDashboard");
                      setActiveLink("CustomerDashboard");
                      navigate("CustomerDashboard");
                      handleDashboardMenuClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "10px 16px",
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        color: "#0071BC",
                        fontWeight: 600,
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Customer
                  </MenuItem>
                  <MenuItem
                    selected={activeLink === "DepartmentDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "DepartmentDashboard");
                      setActiveLink("DepartmentDashboard");
                      navigate("DepartmentDashboard");
                      handleDashboardMenuClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "10px 16px",
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        color: "#0071BC",
                        fontWeight: 600,
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Department
                  </MenuItem>
                  <MenuItem
                    selected={activeLink === "FeedbackDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "FeedbackDashboard");
                      setActiveLink("FeedbackDashboard");
                      navigate("FeedbackDashboard");
                      handleDashboardMenuClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "10px 16px",
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        color: "#0071BC",
                        fontWeight: 600,
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Feedback
                  </MenuItem>
                </Menu>
              </div>

              {/* Expanded Sidebar Menu */}
              {sidebarExpanded && toggleDashboard && (
                <>
                  <NavItem
                    icon={null}
                    label="Dashboard"
                    isActive={activeLink === "Dashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "Dashboard");
                      setActiveLink("Dashboard");
                      navigate("Dashboard");
                    }}
                  />
                  <NavItem
                    icon={null}
                    label="Agent"
                    isActive={activeLink === "AgentDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "AgentDashboard");
                      setActiveLink("AgentDashboard");
                      navigate("AgentDashboard");
                    }}
                  />
                  <NavItem
                    icon={null}
                    label="Customer"
                    isActive={activeLink === "CustomerDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "CustomerDashboard");
                      setActiveLink("CustomerDashboard");
                      navigate("CustomerDashboard");
                    }}
                  />
                  <NavItem
                    icon={null}
                    label="Department"
                    isActive={activeLink === "DepartmentDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "DepartmentDashboard");
                      setActiveLink("DepartmentDashboard");
                      navigate("DepartmentDashboard");
                    }}
                  />
                  <NavItem
                    icon={null}
                    label="Feedback"
                    isActive={activeLink === "FeedbackDashboard"}
                    onClick={() => {
                      localStorage.setItem("SideTab", "FeedbackDashboard");
                      setActiveLink("FeedbackDashboard");
                      navigate("FeedbackDashboard");
                    }}
                  />
                </>
              )}
            </>
          ) : (
            <NavItem
              icon={
                activeLink === "Dashboard" || activeLink === "app" ? (
                  <DashBoardActive width="30" height="25" />
                ) : (
                  <DashBoardIcon width="30" height="25" />
                )
              }
              label="Dashboard"
              isActive={activeLink === "Dashboard"}
              onClick={() => {
                localStorage.setItem("SideTab", "Dashboard");
                setActiveLink("Dashboard");
                navigate("Dashboard");
                setToggleReports(false);
              }}
            />
          )}

          {(global?.$userData?.logindata?.TicketCompaniesAccess === "1" ||
            global?.$userData?.logindata?.TicketCompaniesAccess === "2") && (
            <NavItem
              icon={
                activeLink === "company" ? (
                  <CustomerActiveIcon width="30" height="25" />
                ) : (
                  <CustomerIcon width="30" height="25" />
                )
              }
              label="Companies"
              isActive={activeLink === "company"}
              onClick={() => {
                localStorage.setItem("SideTab", "company");
                setActiveLink("company");
                navigate("Company");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}

          <NavItem
            icon={
              activeLink === "created" ? (
                <CreatedActive width="30" height="25" />
              ) : (
                <Created width="30" height="25" />
              )
            }
            label="Created"
            isActive={activeLink === "created"}
            onClick={() => {
              localStorage.setItem("SideTab", "created");
              setActiveLink("created");
              navigate("Created");
              setToggleDashboard(false);
              setToggleReports(false);
            }}
          />

          <NavItem
            icon={
              activeLink === "myworkspace" ? (
                <MyWorkspaceActive width="30" height="25" />
              ) : (
                <Myworkspace width="30" height="25" />
              )
            }
            label="My Workspace"
            isActive={activeLink === "myworkspace"}
            onClick={() => {
              localStorage.setItem("SideTab", "myworkspace");
              setActiveLink("myworkspace");
              navigate("MyWorkspace");
              setToggleDashboard(false);
              setToggleReports(false);
            }}
          />

          {global?.$userData?.logindata?.crm_app_license_master
            ?.TicketApproval == "Yes" && (
            <NavItem
              icon={
                activeLink === "ticketApproval" ? (
                  <ApprovalActive width="30" height="25" />
                ) : (
                  <ApprovalInactive width="30" height="25" />
                )
              }
              label="Ticket Approval"
              isActive={activeLink === "ticketApproval"}
              onClick={() => {
                localStorage.setItem("SideTab", "ticketApproval");
                setActiveLink("ticketApproval");
                navigate("TicketApproval");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}

          <NavItem
            icon={
              activeLink === "Tagged" ? (
                <CreatedActive width="30" height="25" />
              ) : (
                <Created width="30" height="25" />
              )
            }
            label="Tagged Tickets"
            isActive={activeLink === "Tagged"}
            onClick={() => {
              localStorage.setItem("SideTab", "Tagged");
              setActiveLink("Tagged");
              navigate("TaggedTickets");
              setToggleDashboard(false);
              setToggleReports(false);
            }}
          />

          {(global?.$userData?.logindata?.TicketingDepartmentAdmin == "Yes" ||
            global?.$userData?.logindata?.AccessAdminTicket == "Yes") && (
            <NavItem
              icon={
                activeLink === "teamtickets" ? (
                  <TeamTicketActive width="30" height="25" />
                ) : (
                  <Teamticket width="30" height="25" />
                )
              }
              label="Team Tickets"
              isActive={activeLink === "teamtickets"}
              onClick={() => {
                localStorage.setItem("SideTab", "teamtickets");
                setActiveLink("teamtickets");
                navigate("TeamTickets");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}
          {global?.$userData?.logindata?.AccessAdminTicket === "Yes" && (
            <NavItem
              icon={
                activeLink === "all" ? (
                  <RecurringActiveIcon width="30" height="25" />
                ) : (
                  <Recurring width="30" height="25" />
                )
              }
              label="All"
              isActive={activeLink === "all"}
              onClick={() => {
                localStorage.setItem("SideTab", "all");
                setActiveLink("all");
                navigate("All");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}
          <NavItem
            icon={
              <MenuBookIcon
                style={{
                  width: 30,
                  height: 25,
                  color: activeLink === "knowledge" ? "#232323" : "#fff",
                }}
              />
            }
            label="Knowledge Base"
            isActive={activeLink === "knowledge"}
            endIcon={
              kbPending > 0 ? (
                <span
                  aria-label={`${kbPending} waiting for approval`}
                  style={{
                    minWidth: 20,
                    height: 20,
                    borderRadius: 10,
                    padding: "0 6px",
                    boxSizing: "border-box",
                    background: "#F5A623",
                    color: "#2B1B00",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {kbPending}
                </span>
              ) : null
            }
            onClick={() => {
              localStorage.setItem("SideTab", "knowledge");
              setActiveLink("knowledge");
              navigate("Knowledge");
              setToggleDashboard(false);
              setToggleReports(false);
            }}
          />
          {global?.$userData?.logindata?.AccessAdminTicket == "Yes" && (
            <NavItem
              icon={
                activeLink === "master" ? (
                  <MasterActive width="30" height="25" />
                ) : (
                  <Master width="30" height="25" />
                )
              }
              label="Masters"
              isActive={activeLink === "master"}
              onClick={() => {
                localStorage.setItem("SideTab", "master");
                setActiveLink("master");
                navigate("Master");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}

          {global?.$userData?.logindata?.AccessAdminTicket == "Yes" && (
            <NavItem
              icon={
                activeLink.includes("Reports") ? (
                  <ReportMain
                    width="30"
                    height="25"
                    style={{ color: "#232323" }}
                  />
                ) : (
                  <ReportMain
                    width="30"
                    height="25"
                    style={{ color: "#fff" }}
                  />
                )
              }
              label="Reports"
              isActive={activeLink.includes("Reports")}
              onClick={() => {
                localStorage.setItem("SideTab", "Reports");
                setActiveLink("Reports");
                navigate("Reports");
                setToggleDashboard(false);
                setToggleReports(false);
              }}
            />
          )}

          <NavItem
            icon={
              activeLink === "Notes" ? (
                <NoteActive width="30" height="25" />
              ) : (
                <NotesI width="30" height="25" />
              )
            }
            label="Notes"
            isActive={activeLink === "Notes"}
            onClick={() => {
              localStorage.setItem("SideTab", "Notes");
              setActiveLink("Notes");
              navigate("Notes");
              setToggleDashboard(false);
              setToggleReports(false);
            }}
          />

          <NavItem
            icon={
              activeLink === "MailTicket" ? (
                <UnsubscribeIcon
                  sx={{ color: "black", width: "30px", height: "25px" }}
                />
              ) : (
                <UnsubscribeIcon
                  sx={{ color: "white", width: "30px", height: "25px" }}
                />
              )
            }
            label="Convert To Ticket"
            isActive={activeLink === "MailTicket"}
            onClick={() => {
              localStorage.setItem("SideTab", "MailTicket");
              setActiveLink("MailTicket");
              navigate("mail_to_ticket");
              setToggleReports(false);
              setToggleDashboard(false);
            }}
          />

          <NavItem
            icon={
              activeLink === "LogsPage" ? (
                <RssFeed
                  sx={{ color: "black", width: "30px", height: "25px" }}
                />
              ) : (
                <RssFeed
                  sx={{ color: "white", width: "30px", height: "25px" }}
                />
              )
            }
            label="Logs"
            isActive={activeLink === "LogsPage"}
            onClick={() => {
              localStorage.setItem("SideTab", "LogsPage");
              setActiveLink("LogsPage");
              navigate("LogsPage");
              setToggleReports(false);
              setToggleDashboard(false);
            }}
          />
        </List>
      </Box>
    </div>
  );

  const drawer1 = ({ openDrawer, onClose, userData }) => {
    const menuItems = [
      {
        label: "My Account",
        icon: AccountBoxIcon,
        action: () => handleMyAccount(),
      },
      {
        label: "Settings",
        icon: Settings,
        action: () => Navigate("Setting"),
      },
      {
        label: "TV Dashboard",
        icon: TvIcon,
        action: () => Navigate("TvDashboard"),
      },
      {
        label: "Release Notes",
        icon: NewReleasesIcon,
        action: () => Navigate("ReleaseNotes"),
      },
    ];

    // Conditionally add Subscription
    // if (userData?.logindata?.AccessAdminTicket === "Yes") {
    //   menuItems.push({
    //     label: "Subscription",
    //     icon: CardMembershipIcon,
    //     action: () => Navigate("Subscription"),
    //   });
    // }

    const handleMenuClick = (action) => {
      action();
      onClose();
    };

    if (!openDrawer) return null;

    return (
      <>
        {/* Backdrop */}
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
          }}
        />

        {/* Drawer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: 450,
            height: "100vh",
            background:
              "linear-gradient(135deg, #0071BC 0%, #2991d6ff 30%, #6fb4e2ff 60%,  #f5f9fc 100%)",
            boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
            zIndex: 1001,
            display: "flex",
            flexDirection: "column",
            animation: "slideInRight 0.3s ease",
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: 16,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  flexDirection: "column",
                  marginTop: 16,
                  padding: 10,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    variant="rounded"
                    sx={styles.fullDp}
                    alt={userData?.logindata?.Name}
                    src={userData?.logindata?.ProfilePictureLink || ""}
                  />
                  <div style={{ color: "#FFFF" }}>
                    <strong>{userData?.logindata?.Name || "User"}</strong>
                    <div style={{ fontSize: 14 }}>
                      {userData?.logindata?.UserEmailId}
                    </div>
                    <div style={{ fontSize: 14 }}>
                      {userData?.logindata?.UserMobileNumber}
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                <XIcon />
              </button>
            </div>
          </div>

          {/* Menu */}
          <div style={{ flex: 1, padding: 16 }}>
            {menuItems.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  style={{
                    width: "100%",
                    background: "transparent",
                    border: "none",
                  }}
                >
                  <button
                    key={i}
                    onClick={() => handleMenuClick(item.action)}
                    style={{
                      width: "auto",
                      padding: 12,
                      background: "transparent",
                      border: "none",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      cursor: "pointer",
                    }}
                  >
                    <Icon />
                    {item.label}
                  </button>
                </div>
              );
            })}

            <hr style={{ opacity: 0.3 }} />

            <button
              onClick={() => {
                setOpenLogout(true);
                onClose();
              }}
              style={{
                width: "100%",
                padding: 12,
                background: "transparent",
                border: "none",
                color: "#dc3545",
                display: "flex",
                gap: 12,
                cursor: "pointer",
              }}
            >
              <Logout style={{ color: "#dc3545" }} />
              Logout
            </button>
          </div>
          <QrCodes />
        </div>

        <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}</style>
      </>
    );
  };

  const handleMyAccount = () => {
    setOpenDrawer(false);
    globalThis?.open(global.congito, "_blank");
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const getSubscriptionAlert = async () => {
    try {
      const { data } = await global.$axios.post("zoho_billing/due_date_alerts");
      if (data?.Status == 200) {
        setSubsContent(data?.Message);
      }
    } catch (error) {
      console.log("zoho_billing/due_date_alerts", error);
    }
  };

  React.useEffect(() => {
    // getSubscriptionAlert();
  }, []);

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "k") {
        event.preventDefault();
        setIsSearch(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          background: "transparent",
          transition: "width 0.3s ease, margin 0.3s ease",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" }, color: "#000" }}
          >
            <MenuIcon />
          </IconButton>

          <Box item sx={{ flexGrow: 1 }}>
            <Grid container>
              <Grid item xs={12} style={styles.firstGrid}>
                {/* {global?.$userData?.logindata?.AccessAdminTicket === "Yes" && (
                  <Box
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography className="shining-text" sx={styles.headText}>
                      {subsContent}
                    </Typography>

                    <Button
                      variant="contained"
                      sx={{
                        minHeight: "22px",
                        maxHeight: "22px",
                        padding: "12px",
                        textTransform: "capitalize",
                        color: "white",
                      }}
                      onClick={() => Navigate("Subscription")}
                    >
                      Subscribe
                    </Button>
                  </Box>
                )} */}
                <Box
                  id="searcBox"
                  sx={styles.searchBorder}
                  onClick={() => setIsSearch(true)}
                >
                  <Box sx={styles.firstBox}>
                    <SearchIcon style={{ color: "#0071BC" }} />
                    <div style={styles.row}> Search...</div>
                  </Box>
                  <Box sx={styles.ctrl}>
                    <span style={{ fontSize: "11px" }}>Ctrl+K</span>
                  </Box>
                </Box>

                <NotificationBell />

                <Tooltip title="Family Products">
                  <IconButton
                    sx={[
                      styles.dpBorder,
                      {
                        paddingX: 0.5,
                      },
                    ]}
                    onClick={() => setDrawerOpen(true)}
                  >
                    <AppsIcon
                      style={{
                        color: "#0071BC",
                        height: "30px",
                        width: "30px",
                      }}
                    />
                  </IconButton>
                </Tooltip>

                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    variant="rounded"
                    sx={styles.dpBorder}
                    alt={global?.$userData?.logindata?.Name}
                    src={global?.$userData?.logindata?.ProfilePictureLink || ""}
                  />
                </IconButton>

                <Menu
                  anchorEl={mobileDrawer}
                  id="account-menu"
                  open={mobileDrawer}
                  onClose={handleCloseUserMenu}
                  onClick={handleCloseUserMenu}
                  slotProps={{
                    paper: {
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "top" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleCloseUserMenu();
                      Navigate("Setting");
                    }}
                  >
                    <ListItemIcon>
                      <Settings fontSize="small" />
                    </ListItemIcon>
                    Settings
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseUserMenu();
                      Navigate("TvDashboard");
                    }}
                  >
                    <ListItemIcon>
                      <TvIcon fontSize="small" />
                    </ListItemIcon>
                    Tv Dashboard
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseUserMenu();
                      Navigate("ReleaseNotes");
                    }}
                  >
                    <ListItemIcon>
                      <NewReleasesIcon fontSize="small" />
                    </ListItemIcon>
                    Release Notes
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      handleCloseUserMenu();
                      setOpenLogout(true);
                    }}
                  >
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>

      <IconButton
        id="iconToggle"
        onClick={() => setSidebarExpanded(!sidebarExpanded)}
        sx={{
          position: "absolute",
          left: sidebarExpanded ? 190 : 50,
          top: "2%",
          color: "#fff",
          backgroundColor: "#0071BC",
          width: "40px",
          height: "40px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          display: { xs: "none", sm: "flex" },
          transition: "left 0.3s ease, transform 0.2s ease",
          "&:hover": {
            backgroundColor: "#005a94",
            transform: "scale(1.1)",
          },
          zIndex: 1300,
        }}
      >
        {sidebarExpanded ? <ChevronLeftIcon /> : <MenuIcon />}
      </IconButton>

      {/*Mobile*/}
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          transition: "width 0.3s ease",
        }}
        aria-label="mailbox folders"
      >
        <TreeOne style={{ width: 0, padding: 0 }} />

        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidthExpanded,
              background: "#0071BC",
            },
          }}
        >
          {drawer}
        </Drawer>

        {/*Web*/}
        <Drawer
          variant="permanent"
          className="Main"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              border: "unset",
              overflow: "auto",
              background: "#0071BC",
              overflowY: "auto",
              height: "100vh",
              width: `${drawerWidth}px`,
              transition: "width 0.3s ease",
              boxShadow: "4px 0 12px rgba(0, 0, 0, 0.15)",
            },
          }}
          open
        >
          {drawer}
        </Drawer>

        <Drawer
          anchor="right"
          variant="temporary"
          open={openDrawer}
          onClose={handleCloseUserMenu}
        >
          {drawer1({
            openDrawer,
            onClose: handleCloseUserMenu,
            userData: global?.$userData,
          })}
        </Drawer>
      </Box>
      {/*Main Content*/}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          height: "100vh",
          overflow: "hidden",
                    // backgroundImage:
          //   "linear-gradient(-180deg, #FFF 0%, rgba(10, 124, 198, 0.2) 100%)",
          background: "#FFFFFF",
        }}
      >
        <Toolbar />
        <Box
          sx={{
            height: "calc(100vh - 64px)",
            overflowY: "auto",
            p: 3,
            pb: 1,
          }}
        >
          <Content>
            <React.Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
              <Outlet />
            </React.Suspense>
          </Content>
        </Box>
        {openLogout && (
          <LogoutConfirmPop
            logout={logout}
            openLogout={openLogout}
            setOpenLogout={setOpenLogout}
          />
        )}

        {isSearch && (
          <GlobalSearch isSearch={isSearch} setIsSearch={setIsSearch} />
        )}
        {drawerOpen && (
          <FamilyProducts
            onOpen={drawerOpen}
            onDismiss={setDrawerOpen}
            emailId={global?.$userData?.logindata.UserEmailId}
          />
        )}
      </Box>
    </Box>
  );
}

export default MainLayout;

const styles = {
  searchInput: {
    outline: "none",
    backgroundColor: "transparent",
    border: "none",
  },
  touchbtn: {
    color: "black",
    background: "#FFFFFF",
    fontWeight: 600,
    letterSpacing: "0.5px",
    padding: "10px 5px",
    margin: "5px 0px",
  },
  untouchbtn: {
    color: "#FFFFFF",
    padding: "10px 5px",
  },
  touchbtn1: {
    dispay: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "black",
    background: "#FFFFFF",
    fontWeight: 600,
    letterSpacing: "0.5px",
    padding: "10px 5px",
    margin: "5px 0px",
  },
  checkboxLabel: {
    border: "1px solid black",
    fontWeight: "100",
    fontSize: "20px",
  },
  dashBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 5px",
    background: "#FFFFFF",
    cursor: "pointer",
  },
  dashBtn1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 5px",
    cursor: "pointer",
    color: "#FFFFFF",
  },
  row: {
    color: "#0071BC",
    fontSize: "14px",
    fontWeight: 500,
  },
  row1: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#232323",
  },
  headText: { fontSize: "14px", color: "#232323" },
  dpBorder: {
    border: "1px solid #0071BC",
    height: 38,
    borderRadius: 2,
  },
  fullDp: {
    height: 80,
    width: 80,
    borderRadius: 2,
  },
  searchBorder: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    background: "transparent",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#0071BC",
    borderRadius: "10px",
    width: 170,
    height: 38,
    paddingX: 1,
    justifyContent: "space-between",
    cursor: "pointer",
  },
  ctrl: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    paddingX: 1,
    paddingY: 0.5,
    backgroundColor: "#f5f5f5",
    borderRadius: 2,
    border: "1px solid #e0e0e0",
    fontSize: "12px",
    color: "#0071BC",
    fontWeight: 500,
  },
  firstGrid: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  firstBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flex: 1,
  },
};
